"use client";

import type { Route } from "next";
import Tooltip from "@mui/material/Tooltip";
import Link from "next/link";
import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import Icon from "@/components/icon";
import { SocialLinkProps } from "@/TS/Interfaces/global_interfaces";
import { IconType } from "@/TS/Types/global_types";

const SocialLink = forwardRef<HTMLAnchorElement, SocialLinkProps>(
  ({ iconSize, href, type, className, ...rest }, ref) => {
    let icon = "" as IconType;
    let label = "";
    let target = "";

    switch (type) {
      case "facebook":
        icon = "facebook";
        label = "Facebook";
        target = "_blank";
        break;
      case "linkedin":
        icon = "linkedin";
        label = "LinkedIn";
        target = "_blank";
        break;
      case "instagram":
        icon = "instagram";
        label = "Instagram";
        target = "_blank";
        break;
      case "phone":
        icon = "phone";
        label = href ?? "Téléphone";
        break;
      case "email":
        icon = "mail";
        label = href ?? "Email";
        break;
    }

    if (type === "email")
      return (
        <Tooltip title={label} arrow>
          <a
            href={"mailto:" + href}
            ref={ref}
            {...rest}
            className={twMerge(
              `rounded-full flex justify-center items-center m-0.5 w-fit bg-secondary text-white ${className}`,
            )}
          >
            <Icon icon={icon} size={iconSize ?? 35} />
          </a>
        </Tooltip>
      );

    if (type === "phone")
      return (
        <Tooltip title={label} arrow>
          <Link
            ref={ref}
            {...rest}
            className={twMerge(
              `rounded-full flex justify-center items-center m-0.5 w-fit bg-secondary text-white ${className}`,
            )}
            href={`tel:${href ?? "/"}`}
          >
            <Icon icon={icon} size={iconSize ?? 35} />
          </Link>
        </Tooltip>
      );

    return (
      <Tooltip title={label} arrow>
        <Link
          ref={ref}
          {...rest}
          href={(href ?? "/") as Route}
          target={target}
          className={twMerge(
            `rounded-full flex justify-center items-center m-0.5 w-fit bg-secondary text-white ${className}`,
          )}
        >
          <Icon icon={icon} size={iconSize ?? 35} />
        </Link>
      </Tooltip>
    );
  },
);

SocialLink.displayName = "SocialLink";

export default React.memo(SocialLink);
